<div class="api-keys-settings">
  <h1>{{ 'SETTINGS.API_KEYS.TITLE' | translate }}</h1>

  @let newTokenValue = apiKeysService.newApiKeyToken();
  @if (newTokenValue) {
    <div class="new-token-alert">
      <div class="new-token-header">
        <h3>{{ 'SETTINGS.API_KEYS.NEW_API_KEY' | translate }}</h3>
        <orbit-button
          [icon]="faClose"
          [title]="'SETTINGS.API_KEYS.CLOSE' | translate"
          (click)="closeTokenAlert()"></orbit-button>
      </div>
      <div class="token-container">
        <input
          class="token-value"
          [type]="showToken() ? 'text' : 'password'"
          [value]="newTokenValue"
          readonly />
        <div class="token-actions">
          <orbit-button
            [icon]="showToken() ? faEyeSlash : faEye"
            [title]="
              (showToken() ? 'SETTINGS.API_KEYS.HIDE_TOKEN' : 'SETTINGS.API_KEYS.SHOW_TOKEN')
                | translate
            "
            (click)="toggleTokenVisibility()"></orbit-button>
          <orbit-button
            [icon]="faCopy"
            [title]="'SETTINGS.API_KEYS.COPY_TOKEN' | translate"
            (click)="copyToken(newTokenValue)"></orbit-button>
        </div>
      </div>
      <p class="token-warning">{{ 'SETTINGS.API_KEYS.TOKEN_WARNING' | translate }}</p>
    </div>
  }

  <div class="actions">
    <orbit-button
      [icon]="faPlus"
      label="{{ 'SETTINGS.API_KEYS.ADD_KEY' | translate }}"
      (click)="onAdd()"></orbit-button>
  </div>
  @let loadingValue = loading();

  @if (!loadingValue) {
    <div class="keys-table-container">
      <table class="keys-table">
        <thead>
          <tr>
            <th>{{ 'SETTINGS.API_KEYS.NAME' | translate }}</th>
            <th>{{ 'SETTINGS.API_KEYS.KEY_ID' | translate }}</th>
            <th>{{ 'SETTINGS.API_KEYS.EXPIRES_AT' | translate }}</th>
            <th>{{ 'SETTINGS.API_KEYS.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (key of apiKeys()?.apiKeys; track key.keyId) {
            <tr>
              <td>{{ key.name }}</td>
              <td>{{ key.keyId || '-' }}</td>
              <td>{{ key.expiresAt | date: 'medium' }}</td>
              <td class="actions-cell">
                <orbit-button
                  [icon]="faEdit"
                  title="{{ 'SETTINGS.API_KEYS.EDIT_KEY' | translate }}"
                  (click)="onEdit(key)"></orbit-button>
                <orbit-button
                  [icon]="faTrash"
                  title="{{ 'SETTINGS.API_KEYS.DELETE_KEY' | translate }}"
                  (click)="deleteApiKey(key)"></orbit-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
